const StorageKey = Object.freeze({
	UserCredentials: 'maasenpeel-credentials',
	PreferredLanguage: 'maasenpeel-preferred-language',
	Theme: 'maasenpeel-theme',
});

export default StorageKey;
